/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import ThemedIcon from '../../components/common/ThemedIcon';
import styled from 'styled-components';

import Header from '../../components/common/Header';
import tickIcon from '../../images/common/check.svg';
import pdfIcon from '../../images/lab-test/pdf-icon.svg';
import { connect } from 'react-redux';
import Tappable from 'react-tappable/lib/Tappable';
import {
  fetchClaimStatusSummaryV2,
  fetchClaimSummaryV2,
  uploadClaimsDocuments,
  getFeedbackDetails,
  knowMoreDetails,
  getDeficiencyQueryCount,
} from '../../services';
import StyledTappable from '../../components/common/StyledTappable';
import MessageModal from '../../components/pharmacy/MessageModal';
import { logEvent } from '../../utils/logEvent';
import LoadingComponent from '../../components/common/LoadingComponent';
import DetailsIcon from '../../images/reimbursement/detail_image.svg';
import DocumentUploadIcon from '../../images/reimbursement/Paper_Upload.svg';
import CheckTick from '../../images/reimbursement/Check_sq-fr.svg';
import NotificationIcon from '../../images/reimbursement/notification.svg';
import { FaTimes } from 'react-icons/fa';
import AlertIcon from '../../images/reimbursement/Alert.svg';
import RuppesIcon from '../../images/reimbursement/ruppe_icon.svg';
import CircleCheckIcon from '../../images/reimbursement/circle_check.svg';
import DeniedPermisionIcon from '../../images/reimbursement/denien_permission.svg';
import ClaimsKnowMore from '../../components/claims/ClaimsKnowMore';
import moment from 'moment';
import UploadModal from '../../components/common/UploadModal';
import { openFileViewer } from '../../actions';
import { capitalizeFirstLetter } from '../../utils/random-string';
import chartIcon from '../../images/reimbursement/chart.svg';
import chatIcon from '../../images/reimbursement/chat.svg';
import blackArrowRight from '../../images/reimbursement/black-arrow-right.svg';
import redInfo from '../../images/reimbursement/red-info.svg';
import lightBlueInfo from '../../images/reimbursement/light-blue-info.svg';
import { replacePlaceholdersWithEffect } from '../../utils/replacePlaceholdersWithEffect';
import ClaimEtaRow, {
  ClaimStagePill,
} from '../../components/claims/ClaimEtaRow';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  overflow-y: hidden;
`;

const BodyContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 18px 14px;
  background: #fff;
`;

const StepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin-bottom: 1rem;
`;

const AttachedFilesContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  align-self: stretch;
  align-items: center;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  flex-wrap: wrap;
`;

const AttachFileContainer = styled(Tappable)`
  position: relative;
  flex-shrink: 0;
  margin: 0 0.5rem;
  background-image: ${() => `url(${pdfIcon})`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: 2rem;
  width: 45px;
  height: 64px;
  margin-top: 0.25rem;
  margin-bottom: 0.5rem;
  border-radius: 4px;
`;

const AttachImageContainer = styled(Tappable)`
  position: relative;
  flex-shrink: 0;
  margin: 0 0.5rem;
  background-image: ${(props) => `url(${props.fileUrl})`};
  background-repeat: no-repeat;
  background-size: cover;
  width: 45px;
  height: 64px;
  margin-top: 0.25rem;
  margin-bottom: 0.5rem;
  border-radius: 4px;
  box-shadow: 0px 0px 1px 0px black;
`;

const StatusIcon = styled.div`
  box-sizing: border-box;
  border-radius: 50%;
  margin-left: -12px;
  height: 24px;
  width: 24px;
  align-self: flex-start;
  border: 3px solid;
  border-color: ${(props) =>
    props.active ? 'var(--primary-button, #714fff)' : '#EBEAF5'};
  background: #fff;
  ${(props) =>
    props.active
      ? `
  display: flex;
  align-items: center;
  justify-content: center;

  &::after {
    content: '';
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background: var(--primary-button, #714fff);
  }`
      : ''}
`;

const StatusIconImg = styled.img`
  background: var(--primary-button, #714fff);
  margin-left: -12px;
  border-radius: 50%;
  align-self: flex-start;
  height: 24px;
  width: 24px;
`;

const StatusIncomDoc = styled.img`
  background: #ff754c;
  margin-left: -12px;
  border-radius: 50%;
  align-self: flex-start;
  height: 24px;
  width: 24px;
`;

const StepTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #f5f4ff;
  border-radius: 8px;
  padding: 12px 16px;
  margin: 12px;
  margin-top: -12px;
  margin-right: 0;
  width: 100%;
`;

const StepstextContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 15px;
  padding: 0 12px;
  width: 100%;
`;

const StatusContainer2 = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  background: #ffffff;
  border: 1px solid
    ${(props) => props.borderColor || 'var(--primary-button, #714fff)'};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);
  border-radius: 12px;
`;
const DateText = styled.p`
  margin-right: 3px;
  margin-bottom: 24px;

  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 15px;
  text-align: right;
  color: #767787;
  position: absolute;
  right: 2%;
  bottom: 0px;
`;

const StatusDetail = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
  border-bottom-color: ${(props) => (props.bottomBorder ? '#f0f3f6' : '#fff')};
  border-bottom-width: ${(props) => (props.bottomBorder ? '1px' : '0px')};
`;

const StatusSubLableText = styled.p`
  margin-top: 5px;

  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
  display: flex;
  align-items: center;
  letter-spacing: 0.5px;
  color: #302e6b;
`;

const Text3 = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.25px;
  line-height: 18px;
  flex: 1;
  font-size: 14px;
  line-height: 16px;
  color: ${(props) => (props.active ? '#413958' : '#767787')};
`;

const CloseContainer = styled(StyledTappable)`
  position: absolute;
  top: -5px;
  right: -5px;
  background: #ff7268;
  border-radius: 6px;
  padding: 2px;
`;

const CloseIcon = styled(FaTimes)`
  font-size: 14px;
  color: white;
`;

const AttachmentInput = styled.input`
  display: none;
`;

const TabsContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: #f0f3f6;
  gap: 4px;
  width: 100%;
  border-radius: 22px;
  padding: 4px;
  margin: 10px 0px 4px;
  box-sizing: border-box;
  z-index: 2;
  position: relative;
`;

const TabButton = styled.button`
  border-radius: 20px;
  font-weight: ${({ active }) => (active ? 600 : 500)};
  font-size: 12px;
  line-height: 18px;
  width: 100%;
  padding: 10px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: ${({ active }) => (active ? '#0F0B28' : '#585969')};
  background: ${({ active }) => (active ? '#FFFFFF' : 'transparent')};
  box-shadow: ${({ active }) =>
    active ? '0px 2px 6px rgba(15, 11, 40, 0.08)' : 'none'};
  transition:
    background-color 0.2s ease,
    color 0.2s ease;
`;

const ViewQueryCta = styled.button`
  border-radius: 12px;
  color: '0F0B28';
  padding: 12px;
  text-align: center;
  margin: 12px 0 0;
  width: 100%;
  border: 1px solid #ff754c;
  font-weight: 500;
  line-height: 14.52px;
  font-size: 12px;
`;

const QueryBox = styled.div`
  display: flex;
  padding: 16px 12px;
  border: ${({ actionTaken }) =>
    actionTaken ? '1px solid #F0F3F6' : '1px solid rgba(255, 117, 76, 0.3)'};
  border-radius: 12px;
  margin: 10px 5px;
  gap: 12px;
`;

const BadgeBox = styled.span`
  padding: 4px 8px;
  border-radius: 20px;
  background-color: ${({ actionTaken }) =>
    actionTaken ? 'rgba(207, 200, 255, 0.5)' : '#FCEAEA'};
  color: ${({ actionTaken }) =>
    actionTaken ? 'var(--primary-button, #714fff)' : '#FF754C'};
  font-weight: 700;
  line-height: 15px;
  font-size: 10px;
`;

const TimeBox = styled.span`
  font-weight: 400;
  font-size: 10px;
  line-height: 15px;
  color: #767787;
`;

const TopDisclaimerContainer = styled.div`
  background-color: #e5fffd;
  border-radius: 12px;
  margin-bottom: 16px;
`;
const TopDisclaimer = styled.div`
  background-image: url(${(props) => props.backgroundImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 100px;
`;

class ClaimsSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stage: 1,
      loading: true,
      claimInfo: null,
      documents: [],
      documentsDeficient: [],
      documentsDeficientDetails: null,
      claimInfoV2: {},
      status: [],
      labReport: [],
      perscriptionFile: [],
      invoiceFile: [],
      disabilityCertificateFile: [],
      otherDocumentFiles: [],
      borderColor: '#FF865C',
      invoiceFiles: [],
      labReports: [],
      showUploadOption: false,
      prescriptionFiles: [],
      invoiceFileParts: [],
      prescriptionFileParts: [],
      medsInvoiceFileParts: [],
      labsInvoiceFileParts: [],
      labsReportFileParts: [],
      merParts: [],
      showMessageModal: false,
      modalHeader: '',
      modalMessage: '',
      goBack: true,
      claimStatusDetails: [],
      paymentDetails: {},
      showKnowMoreModal: false,
      documentUploadExpired: false,
      knowMoreDetails: [],
      knowMoreCopayPercentage: null,
      knowMoreTotals: {},
      activeTab: 'claimstatus',
      queryHistory: [],
      cashlessSavingCard: '',
    };

    this.state.claimId =
      props.location.state?.claimId ||
      new URLSearchParams(props.location.search).get('claimId');

    if (
      props.location?.state?.goBack &&
      props.location?.state?.goBack !== null
    ) {
      this.state.goBack = props.location.state.goBack;
    }
  }

  componentDidMount() {
    if (this.state.claimId) {
      this.getClaimStatusV2();
      // this.getClaimStatus();
      this.ClaimStatusSummaryV2();
    }
  }

  getDeficiencyQueryCounts = (reimbursementId) => {
    this.setState({
      loading: true,
    });
    getDeficiencyQueryCount(this.props.authToken, reimbursementId)
      .then((res) => {
        this.setState({
          loading: false,
          queryHistory: res?.result.length > 0 ? res?.result : [],
        });
      })
      .catch((err) => {
        console.error('Error fetching deficiency query counts:', err);
        this.setState({
          loading: false,
        });
      });
  };

  getClaimStatusV2 = () => {
    const { claimId } = this.state;
    const { authToken } = this.props;

    fetchClaimSummaryV2(claimId, authToken)
      .then((res) => {
        const { claimInfo } = res;
        const documents = claimInfo.documents || [];

        const invoiceFile = documents.filter((doc) => doc.type === 'invoice');
        const prescriptionFile = documents.filter(
          (doc) => doc.type === 'prescription'
        );
        const merFile = documents.filter((doc) => doc.type === 'mer');
        const labReport = documents.filter((doc) => doc.type === 'lab-report');
        const disabilityCertificateFile = documents.filter(
          (doc) => doc.type === 'disability-certificate'
        );

        const status = claimInfo.status || [];

        const documentsDeficientDetails = status.find(
          (s) =>
            s.state === 'documents-deficient' &&
            s.type === 'documents-incomplete'
        );

        const documentUploadExpired = status.find((ele) => {
          if (
            ele.type === 'upload-document' &&
            ele.active &&
            ele.activeDateFormat
          ) {
            return (
              moment().diff(
                moment(ele.activeDateFormat, 'DD-MM-YYYY'),
                'days'
              ) > 0
            );
          }
          return false;
        });

        this.setState({
          loading: false,
          claimInfoV2: claimInfo,
          status,
          documentUploadExpired: Boolean(documentUploadExpired),
          documentsDeficient: claimInfo.documentsDeficient || [],
          documentsDeficientDetails: documentsDeficientDetails || null,
          requestStatus: documentsDeficientDetails
            ? documentsDeficientDetails.state
            : null,
          invoiceFile,
          prescriptionFile,
          merFile,
          labReport,
          disabilityCertificateFile,
          cashlessSavingCard: claimInfo.cashlessSavingCard,
        });

        console.log('Document Upload Expired:', Boolean(documentUploadExpired));
        console.log('Documents Deficient Details:', this.state.claimInfoV2);

        return claimInfo.reimbursementId;
      })
      .then((reimbursementId) => {
        if (reimbursementId) {
          this.getDeficiencyQueryCounts(reimbursementId);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  ClaimStatusSummaryV2 = () => {
    fetchClaimStatusSummaryV2(this.state.claimId, this.props.authToken)
      .then((res) => {
        console.log('status', res);
        this.setState({
          claimStatusDetails: res.claimInfo,
          paymentDetails: res.claimInfo.paymentDetails,
          otherDocumentFiles: (res.claimInfo.documents || []).filter(
            (doc) => doc.type === 'other'
          ),
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onAttachPhoto() {
    document.querySelector('#photoAttachment').click();
  }

  onAttachFile() {
    document.querySelector('#fileAttachment').click();
  }
  onImageDataReceive = () => {
    this.setState({ showModal: false });
    const inputElem = document.getElementById('photoAttachment');

    const file = inputElem.files[0];
    console.log({ file });
    if (this.state.imageType === 'invoice') {
      this.setState({
        invoiceFileParts: [
          ...this.state.invoiceFileParts,
          {
            name: 'invoiceFile',
            filename: file.name,
            data: file,
            type: 'image/jpeg',
          },
        ],
      });
    } else if (this.state.imageType === 'prescription') {
      console.log('s', this.state.imageType);
      this.setState({
        prescriptionFileParts: [
          ...this.state.prescriptionFileParts,
          {
            name: 'prescriptionFile',
            filename: file.name,
            data: file,
            type: 'image/jpeg',
          },
        ],
      });
    } else if (this.state.imageType === 'meds-invoice') {
      this.setState({
        medsInvoiceFileParts: [
          ...this.state.medsInvoiceFileParts,
          {
            name: 'medicineInvoice',
            filename: file.name,
            data: file,
            type: 'image/jpeg',
          },
        ],
      });
    } else if (this.state.imageType === 'labs-invoice') {
      this.setState({
        labsInvoiceFileParts: [
          ...this.state.labsInvoiceFileParts,
          {
            name: 'labInvoice',
            filename: file.name,
            data: file,
            type: 'image/jpeg',
          },
        ],
      });
    } else if (this.state.imageType === 'lab-report') {
      this.setState({
        labsReportFileParts: [
          ...this.state.labsReportFileParts,
          {
            name: 'labReport',
            filename: file.name,
            data: file,
            type: 'image/jpeg',
          },
        ],
      });
    } else if (this.state.imageType === 'mer') {
      this.setState({
        merParts: [
          ...this.state.merParts,
          {
            name: 'merFile',
            filename: file.name,
            data: file,
            type: 'image/jpeg',
          },
        ],
      });
    }
  };

  onPDFDataReceive = () => {
    this.setState({ showModal: false });
    const inputElem = document.getElementById('fileAttachment');

    const file = inputElem.files[0];
    if (this.state.imageType === 'invoice') {
      this.setState({
        invoiceFileParts: [
          ...this.state.invoiceFileParts,
          {
            name: 'invoiceFile',
            filename: file.name,
            data: file,
            type: 'application/pdf',
          },
        ],
      });
    } else if (this.state.imageType === 'prescription') {
      this.setState({
        prescriptionFileParts: [
          ...this.state.prescriptionFileParts,
          {
            name: 'prescriptionFile',
            filename: file.name,
            data: file,
            type: 'application/pdf',
          },
        ],
      });
    } else if (this.state.imageType === 'meds-invoice') {
      this.setState({
        medsInvoiceFileParts: [
          ...this.state.medsInvoiceFileParts,
          {
            name: 'medicineInvoice',
            filename: file.name,
            data: file,
            type: 'application/pdf',
          },
        ],
      });
    } else if (this.state.imageType === 'labs-invoice') {
      this.setState({
        labsInvoiceFileParts: [
          ...this.state.labsInvoiceFileParts,
          {
            name: 'labInvoice',
            filename: file.name,
            data: file,
            type: 'application/pdf',
          },
        ],
      });
    } else if (this.state.imageType === 'lab-report') {
      this.setState({
        labsReportFileParts: [
          ...this.state.labsReportFileParts,
          {
            name: 'labReport',
            filename: file.name,
            data: file,
            type: 'application/pdf',
          },
        ],
      });
    } else if (this.state.imageType === 'mer') {
      this.setState({
        merParts: [
          ...this.state.merParts,
          {
            name: 'merFile',
            filename: file.name,
            data: file,
            type: 'application/pdf',
          },
        ],
      });
    }
  };
  uploadDocs = (s) => {
    this.setState({ uploadingImage: true });
    const { baseUrl, authToken } = this.props;
    // console.log({ state: this.state, s }, '[updateReimbursement]');
    console.log('h', s);
    const {
      invoiceFileParts,
      prescriptionFileParts,
      claimInfoV2,
      labsReportFileParts,
    } = this.state;
    logEvent('OPD Reimbursement Status Document Uploaded', {
      referenceId: claimInfoV2.reimbursementId,
      patientName: claimInfoV2.patientInfo
        ? claimInfoV2.patientInfo.name
        : null,
      procedureName: claimInfoV2.procedureName,
    });

    const formData = new FormData();
    formData.append('date', claimInfoV2.admissionDate);
    formData.append('reimbursementId', claimInfoV2.reimbursementId);
    if (invoiceFileParts.length > 0) {
      // body.push(invoiceFileParts);
      invoiceFileParts.forEach((file) => {
        formData.append('invoiceFile', file.data);
      });
    }
    if (labsReportFileParts.length > 0) {
      // body.push(labsReportFileParts);
      labsReportFileParts.forEach((file) => {
        formData.append('labReport', file.data);
      });
    }
    if (prescriptionFileParts.length > 0) {
      // body.push(prescriptionFileParts);
      prescriptionFileParts.forEach((file) => {
        formData.append('prescriptionFile', file.data);
      });
    }
    uploadClaimsDocuments(formData, authToken)
      .then((apiResponse) => {
        console.log({ apiResponse, baseUrl }, 'uploadFileUrl response');
        if (apiResponse.message === 'success') {
          this.setState({
            uploadingImage: false,
            showMessageModal: true,
            modalHeader: 'Additional Documents Submitted',
            modalMessage:
              'Please refer to the documents section below to see all uploaded documents',
          });
        } else if (apiResponse.message === 'failure') {
          this.setState({
            modalHeader: 'Error',
            showMessageModal: true,
            uploadingImage: false,
            modalMessage: apiResponse.errorMessage,
          });
        } else {
          this.setState({
            modalHeader: 'Image Not Supported',
            showMessageModal: true,
            uploadingImage: false,
            modalMessage: 'File format not supported! Upload a jpg/jpeg image.',
          });
        }
      })
      .catch((err) => {
        console.log({ err }, 'error response while calling uploadFileUrl');
        this.setState({ uploadingImage: false });
      });
    // } else {
    //   this.setState({ uploadingImage: false });
    //   alert('Oops', 'Please upload all required documents.');
    // }
  };

  updateReimbursement = (s) => {
    console.log({ state: this.state, s }, '[updateReimbursement]');
    this.setState({ uploadingImage: true });
    const { baseUrl, authToken } = this.props;
    // console.log({ state: this.state, s }, '[updateReimbursement]');
    console.log('h', s);
    const {
      invoiceFileParts,
      prescriptionFileParts,
      prescriptionFiles,
      invoiceFiles,
      claimInfoV2,
      documentsDeficient,
      labsReportFileParts,
    } = this.state;
    logEvent('OPD Reimbursement Status Document Uploaded', {
      referenceId: claimInfoV2.reimbursementId,
      patientName: claimInfoV2.patientInfo
        ? claimInfoV2.patientInfo.name
        : null,
      procedureName: claimInfoV2.procedureName,
    });

    const formData = new FormData();
    formData.append('date', claimInfoV2.admissionDate);
    formData.append('reimbursementId', claimInfoV2.reimbursementId);
    formData.append(
      'requestStatus',
      s.type === 'documents-incomplete' && s.showDetails ? 1 : 0
    );
    if (
      ((prescriptionFiles.length > 0 || prescriptionFileParts.length > 0) &&
        (invoiceFileParts.length > 0 || invoiceFiles.length) &&
        !(s.type === 'documents-incomplete' && s.showDetails)) ||
      (((documentsDeficient.includes('prescription') &&
        prescriptionFileParts.length > 0) ||
        !documentsDeficient.includes('prescription')) &&
        ((documentsDeficient.includes('invoice') &&
          invoiceFileParts.length > 0) ||
          !documentsDeficient.includes('invoice')) &&
        ((documentsDeficient.includes('lab-report') &&
          labsReportFileParts.length > 0) ||
          !documentsDeficient.includes('lab-report')) &&
        s.type === 'documents-incomplete' &&
        s.showDetails)
    ) {
      if (invoiceFileParts.length > 0) {
        // body.push(invoiceFileParts);
        invoiceFileParts.forEach((file) => {
          formData.append('invoiceFile', file.data);
        });
      }
      if (labsReportFileParts.length > 0) {
        // body.push(labsReportFileParts);
        labsReportFileParts.forEach((file) => {
          formData.append('labReport', file.data);
        });
      }
      if (prescriptionFileParts.length > 0) {
        // body.push(prescriptionFileParts);
        prescriptionFileParts.forEach((file) => {
          formData.append('prescriptionFile', file.data);
        });
      }
      uploadClaimsDocuments(formData, authToken)
        .then((apiResponse) => {
          console.log({ apiResponse, baseUrl }, 'uploadFileUrl response');
          if (apiResponse.message === 'success') {
            this.setState({
              uploadingImage: false,
              showMessageModal: true,
              modalHeader: 'Additional Documents Submitted',
              modalMessage:
                'Please refer to the documents section below to see all uploaded documents',
            });
          } else if (apiResponse.message === 'failure') {
            this.setState({
              modalHeader: 'Error',
              showMessageModal: true,
              uploadingImage: false,
              modalMessage: apiResponse.errorMessage,
            });
          } else {
            this.setState({
              modalHeader: 'Image Not Supported',
              showMessageModal: true,
              uploadingImage: false,
              modalMessage:
                'File format not supported! Upload a jpg/jpeg image.',
            });
          }
        })
        .catch((err) => {
          console.log({ err }, 'error response while calling uploadFileUrl');
          this.setState({ uploadingImage: false });
        });
    } else {
      this.setState({ uploadingImage: false });
      alert('Oops', 'Please upload all required documents.');
    }
  };
  hideModal = () => {
    this.getClaimStatusV2();
    // this.getClaimStatus();
    this.setState({
      showMessageModal: false,
      showKnowMoreModal: false,
      showModal: false,
    });
  };

  handleOutsideClick = (e) => {
    // ignore clicks on the component itself
    if (this.node && this.node.contains(e.target)) {
      return;
    }
    this.setState({
      showModal: false,
      showUploadOption: false,
    });
  };

  handleAttachment = (type) => {
    if (type === 'photo') this.onAttachPhoto();
    else this.onAttachFile();
  };

  onProceed = () => {
    knowMoreDetails(
      this.state.claimInfoV2.reimbursementId,
      this.props.authToken
    )
      .then((res) => {
        console.log(res);
        const data = res?.data ?? [];
        const lastItem = data.at(-1);

        this.setState({
          knowMoreDetails: data,
          knowMoreCopayPercentage: res?.copayPercentage,
          knowMoreTotals: {
            totalRequestedAmount: lastItem?.totalRequestedAmount,
            totalApprovedAmount: lastItem?.totalApprovedAmount,
          },
          showKnowMoreModal: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  toFeedbackPage = () => {
    // console.log(claimId);
    getFeedbackDetails(
      this.state.claimInfoV2.reimbursementId,
      this.props.authToken
    )
      .then((res) => {
        console.log(res);
        this.props.history.push('/claims/feedback', {
          feedback: res.feedbackInfo,
          claimInfo: res.claimInfo,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  removeFile = (ele, idx) => {
    let PresdeleteImage = this.state.prescriptionFileParts.filter(
      (el, fileindex) => {
        return fileindex !== idx;
      }
    );
    this.setState({
      prescriptionFileParts: PresdeleteImage,
    });

    let invoiceDeleteImage = this.state.invoiceFileParts.filter(
      (elm, fileindx) => {
        return fileindx !== idx;
      }
    );
    this.setState({
      invoiceFileParts: invoiceDeleteImage,
    });
  };

  render() {
    const {
      invoiceFile,
      prescriptionFile,
      status,
      documentsDeficientDetails,
      labReport,
      borderColor,
      showModal,
      invoiceFileParts,
      prescriptionFileParts,
      paymentDetails,
      merFile,
      queryHistory,
      cashlessSavingCard,
      otherDocumentFiles,
    } = this.state;

    const claimStatus = this.state.claimInfoV2?.claimStatus;
    const isClaimApprovedOrSettled =
      claimStatus === 'approved' || claimStatus === 'settled';
    const hasClaimStatusStep = status.some((s) => s.type === 'claim-status');

    const replacements = {
      'Cashless you could have saved more':
        'Cashless Network, you would have saved more',
    };
    const renderUploadedFile = (ele, idx) => {
      const { fileUrl, data, type } = ele;
      if (!fileUrl && !data) {
        return null;
      }
      let typeFile = (type || '').replaceAll('/', '-');
      if (fileUrl && fileUrl.substr(fileUrl.length - 3) === 'pdf') {
        return (
          <AttachFileContainer
            key={fileUrl || window.URL.createObjectURL(data)}
            fileUrl={fileUrl || window.URL.createObjectURL(data)}
            onTap={() => {
              if (fileUrl) {
                this.props.openFileViewer({
                  title: capitalizeFirstLetter(type),
                  contentUrl: fileUrl,
                  type: 'pdf',
                });
              } else {
                document
                  .querySelector(`#image-anchor-${typeFile}-${idx}`)
                  ?.click();
              }
            }}
          >
            <a
              href={fileUrl || window.URL.createObjectURL(data)}
              target="_blank"
              rel="noopener noreferrer"
              id={`image-anchor-${typeFile}-${idx}`}
              style={{ display: 'none' }}
            />
          </AttachFileContainer>
        );
      }
      return (
        <AttachImageContainer
          key={fileUrl || window.URL.createObjectURL(data)}
          fileUrl={fileUrl || window.URL.createObjectURL(data)}
          onTap={() => {
            if (fileUrl) {
              this.props.openFileViewer({
                title: capitalizeFirstLetter(type),
                contentUrl: fileUrl,
                type: 'image',
              });
            } else {
              document
                .querySelector(`#image-anchor-${typeFile}-${idx}`)
                ?.click();
            }
          }}
        >
          {fileUrl ? (
            <a
              href={fileUrl || window.URL.createObjectURL(data)}
              target="_blank"
              rel="noopener noreferrer"
              id={`image-anchor-${typeFile}-${idx}`}
              style={{ display: 'none' }}
            />
          ) : (
            <CloseContainer onTap={() => this.removeFile(ele.name, idx)}>
              <CloseIcon>
                <a
                  href={fileUrl || window.URL.createObjectURL(data)}
                  target="_blank"
                  rel="noopener noreferrer"
                  id={`image-anchor-${typeFile}-${idx}`}
                  style={{ display: 'none' }}
                />
              </CloseIcon>
            </CloseContainer>
          )}
        </AttachImageContainer>
      );
    };

    const renderClaimStatusStep = (ele) => {
      const payment = ele.paymentDetails || paymentDetails || {};
      const rows = [
        {
          label: 'Settled Amount',
          value:
            payment.settledAmount || payment.settledAmount === 0
              ? `₹ ${payment.settledAmount}`
              : null,
        },
        { label: 'UTR Number', value: payment.utrNumber },
        { label: 'Time of transaction', value: payment.timeOfTransaction },
        {
          label: 'Account Number',
          value: payment.AccountNumber || payment.accountNumber,
        },
      ].filter((row) => row.value);

      return (
        <div className="rounded-12 border border-custom1eb865 bg-textbox">
          <div className="flex flex-row items-center px-12px pt-12px">
            <span className="text-body-s font-semibold text-txtlight mr-4px">
              {ele.label}
            </span>
            <img
              src={CircleCheckIcon}
              alt="settled"
              style={{ height: '18px', width: '18px' }}
            />
          </div>
          {rows.length > 0 && (
            <div className="m-12px px-12px pb-8px rounded-12 bg-custom1eb865 bg-opacity-10">
              <div className="flex flex-row items-center py-8px">
                <ThemedIcon
                  src={RuppesIcon}
                  alt="rupees"
                  color="#1eb865"
                  style={{ height: '20px', width: '20px' }}
                />
                <span className="text-body-s font-semibold text-txtlight ml-8px">
                  Payment Details
                </span>
              </div>
              {rows.map((row, rowIdx) => (
                <div
                  key={row.label}
                  className={`flex-start-end align-items-center py-8px ${
                    rowIdx < rows.length - 1
                      ? 'border-b border-txtsecondary-shades4'
                      : ''
                  }`}
                >
                  <span className="text-body-s font-medium text-txtsecondary">
                    {row.label}
                  </span>
                  <span className="text-body-s font-semibold text-txtlight">
                    {row.value}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      );
    };

    const stepsRender = (ele, idx) => {
      return (
        <div
          className={`relative flex ${
            idx + 1 < status.length ? 'border-l-2' : ''
          }`}
          style={
            ele.active === false ||
            (ele.showDetails && status[idx + 1]?.active === false)
              ? { borderColor: '#E3E3E3' }
              : { borderColor: 'var(--primary-button, #714fff)' }
          }
        >
          {(ele.type === 'documents-incomplete' && ele.showDetails === true) ||
          (ele.type === 'upload-document' &&
            this.state.documentUploadExpired === true) ? (
            <StatusIncomDoc
              src={AlertIcon}
              alt="alert"
              height={'24px'}
              width={'24px'}
              style={{
                height: '24px',
                width: '24px',
              }}
            />
          ) : !ele.active ? (
            <StatusIcon completed={false} active={false} />
          ) : ele.active && ele.showDetails === true ? (
            <StatusIcon completed={ele.active} active={ele.active} />
          ) : (
            <StatusIconImg src={tickIcon} alt="tick" />
          )}
          {ele.showDetails === false ? (
            <div
              className={`flex items-center w-100 ${
                ele.dateTime ? 'pb-32px' : 'pb-32px'
              }`}
            >
              <StepTextContainer completed={true} active={true}>
                <div className="flex flex-row items-center justify-between">
                  <div
                    className={`text-body-s font-medium ${
                      ele.active ? 'text-txtlight font-semibold' : 'text-sub'
                    } `}
                  >
                    {ele.label}
                  </div>
                  {ele.type === 'documents-verified' && (
                    <div
                      className="hover flex-shrink-0 ml-8px"
                      onClick={() => {
                        this.onProceed();
                      }}
                    >
                      <p
                        className="text-body-s font-semibold"
                        style={{ color: 'var(--primary-button, #714fff)' }}
                      >
                        Know More
                      </p>
                    </div>
                  )}
                </div>
                <div className="txt-black-500-11">{ele.description}</div>
              </StepTextContainer>
              <DateText>{ele.dateTime}</DateText>
            </div>
          ) : (
            <div style={{ width: '100%' }}>
              <div
                className={`flex items-center ${
                  ele.dateTime ? 'pb-32px' : 'pb-32px'
                }`}
              >
                <StepstextContainer className="mb-12px">
                  {ele.type === 'reimbursement-request' ||
                  ele.type === 'claim-raised' ? (
                    <div className="rounded-12 border border-custom1eb865">
                      <div className="p-12px ">
                        <div className="text-body-s font-semibold text-txtlight border-b border-txtsecondary-shades7 border-solid flex flex-row ">
                          <img
                            src={CheckTick}
                            alt="tick"
                            height={'15px'}
                            width={'15px'}
                            style={{
                              height: '15px',
                              width: '15px',
                            }}
                            className="mr-3"
                          />
                          {ele.label}
                        </div>
                        <div className="p-10px">
                          <div
                            className="p-10px rounded-12 border border-txtsecondary-shades4"
                            style={{
                              background: '#F0F3F6',
                              left: '10px',
                            }}
                          >
                            <div className="txt-black-500-11">
                              {ele.description}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      {ele.type === 'upload-document' ? (
                        this.state.documentUploadExpired ? (
                          <div className="rounded-12 border border-accent2-shades5">
                            <div className="p-12px text-body-s font-semibold text-txtlight">
                              Request Expired
                            </div>
                          </div>
                        ) : (
                          <div>
                            <div className="rounded-12 border border-primary">
                              <div className="p-12px text-body-s font-semibold text-txtlight">
                                {ele.label}
                                <div className="flex flex-row items-center">
                                  <img
                                    height={'10px'}
                                    width={'10px'}
                                    style={{
                                      height: '10px',
                                      width: '10px',
                                    }}
                                    className="mr-1 "
                                    src={NotificationIcon}
                                    alt="notificationicon"
                                  />
                                  <p
                                    className="text-title-sm mr-5 p-64px text-sub"
                                    style={{ fontSize: '11px' }}
                                  >
                                    The window is only active till
                                  </p>
                                  <p>{`${ele.activeDate}`}</p>
                                </div>
                                <div>
                                  {invoiceFileParts.length > 0 && (
                                    <div>
                                      <p className="txt-dgrey-600-12 mt-20 mb-5">
                                        Invoice files
                                      </p>

                                      <AttachedFilesContainer>
                                        {invoiceFileParts.map(
                                          renderUploadedFile
                                        )}
                                        {invoiceFileParts.length > 0 &&
                                          invoiceFileParts.length < 5 && (
                                            <div
                                              class="dashed-add"
                                              style={{
                                                marginTop: '0.25rem',
                                                marginBottom: '0.5rem',
                                                width: 45,
                                              }}
                                              onClick={() => {
                                                this.setState({
                                                  showModal: true,
                                                  showUploadOption: true,
                                                  imageType: 'invoice',
                                                });
                                              }}
                                            >
                                              +
                                            </div>
                                          )}
                                      </AttachedFilesContainer>
                                    </div>
                                  )}
                                  {prescriptionFileParts.length > 0 && (
                                    <div>
                                      <p className="txt-dgrey-600-12 mt-20 mb-5">
                                        Prescription files
                                      </p>

                                      <AttachedFilesContainer>
                                        {prescriptionFileParts.map(
                                          renderUploadedFile
                                        )}
                                        {prescriptionFileParts.length > 0 &&
                                          prescriptionFileParts.length < 5 && (
                                            <div
                                              class="dashed-add"
                                              style={{
                                                marginTop: '0.25rem',
                                                marginBottom: '0.5rem',
                                                width: 45,
                                              }}
                                              onClick={() => {
                                                this.setState({
                                                  showModal: true,
                                                  showUploadOption: true,
                                                  imageType: 'prescription',
                                                });
                                              }}
                                            >
                                              +
                                            </div>
                                          )}
                                      </AttachedFilesContainer>
                                    </div>
                                  )}
                                  {invoiceFileParts.length === 0 && (
                                    <p
                                      className="txt-black-600-14 lab-home-btn-blue-dashed pt-10 pb-10 hover mt-20"
                                      onClick={() => {
                                        this.setState({
                                          showModal: true,
                                          showUploadOption: true,
                                          imageType: 'invoice',
                                        });
                                      }}
                                    >
                                      Upload Invoice
                                    </p>
                                  )}
                                  {prescriptionFileParts.length === 0 && (
                                    <p
                                      className="txt-black-600-14 lab-home-btn-blue-dashed pt-10 pb-10 hover mt-20"
                                      onClick={() => {
                                        this.setState({
                                          showModal: true,
                                          showUploadOption: true,
                                          imageType: 'prescription',
                                        });
                                      }}
                                    >
                                      Upload Prescription
                                    </p>
                                  )}
                                  {(invoiceFileParts.length > 0 ||
                                    prescriptionFileParts.length > 0) && (
                                    <StatusDetail>
                                      <p
                                        className="txt-white-600-14 lab-home-btn-blue pt-10 pb-10 hover mt-20"
                                        style={{
                                          background:
                                            'var(--primary-button, #714fff)',
                                        }}
                                        onClick={() => this.uploadDocs()}
                                      >
                                        Submit
                                      </p>
                                    </StatusDetail>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      ) : ele.type === 'documents-incomplete' ? (
                        <div>
                          <StatusContainer2 borderColor={borderColor}>
                            <StatusDetail bottomBorder>
                              <Text3 active>
                                {documentsDeficientDetails.label}
                              </Text3>
                              <StatusSubLableText>
                                {documentsDeficientDetails.description}
                              </StatusSubLableText>
                            </StatusDetail>
                            <ClaimEtaRow statusItem={ele} className="mt-12px" />
                            <ViewQueryCta
                              onClick={() =>
                                this.setState({ activeTab: 'queryhistory' })
                              }
                            >
                              View Query
                            </ViewQueryCta>
                          </StatusContainer2>
                          {/* <div>{ele.activeDate}</div> */}
                        </div>
                      ) : ele.type === 'documents-verified' ? (
                        <div className="rounded-12 border border-custom1eb865">
                          {/* <div className=" "> */}
                          <div className="p-12px text-body-s font-semibold text-txtlight border-b border-txtsecondary-shades7 border-solid flex flex-row items-center">
                            <img
                              src={CheckTick}
                              alt="tick"
                              height={'24px'}
                              width={'24px'}
                              style={{
                                height: '24px',
                                width: '24px',
                              }}
                              className="mr-4px"
                            />
                            {ele.label}
                            {/* When verification finished. The ETA row below
                                is the forward-looking date, so the two dates
                                sit apart rather than reading as one range. */}
                            {ele.dateTime ? (
                              <span className="ml-auto text-caption-s font-regular text-txtsecondary whitespace-nowrap">
                                {ele.dateTime}
                              </span>
                            ) : null}
                          </div>
                          <div className="px-16px pt-12px">
                            {ele.requestedAmount ? (
                              <div className="flex-start-end align-items-center border-b border-txtsecondary-shades4 py-8px">
                                <span className="text-body-s font-regular text-txtlight">
                                  Requested Amount
                                </span>
                                <span className="text-body-s font-semibold text-txtlight">
                                  {`₹ ${ele.requestedAmount}`}
                                </span>
                              </div>
                            ) : null}
                            {ele.approvedAmount ? (
                              <div className="flex-start-end align-items-center border-b border-txtsecondary-shades4 py-8px">
                                <span className="text-body-s font-regular text-txtlight">
                                  Approved Amount
                                </span>
                                <span className="text-body-s font-semibold text-txtlight">
                                  {`₹ ${ele.approvedAmount}`}
                                </span>
                              </div>
                            ) : null}
                            <ClaimEtaRow statusItem={ele} className="mt-4px" />
                          </div>
                          <div
                            className="txt-black-600-14 w-full hover py-16px text-center"
                            onClick={() => {
                              this.onProceed();
                            }}
                          >
                            <p
                              style={{
                                color: 'var(--primary-button, #714fff)',
                              }}
                            >
                              Know More
                            </p>
                          </div>
                        </div>
                      ) : ele.type === 'claim-status' ? (
                        renderClaimStatusStep(ele)
                      ) : ele.type === 'payment-failed' ? (
                        <div className="rounded-12 border border-accent2-shades4 bg-textbox">
                          {/* Header */}
                          <div className="flex items-center px-16px pt-12px pb-4px">
                            <span className="text-body-s font-semibold text-txtlight">
                              {ele?.label}
                            </span>
                          </div>

                          {/* Body */}
                          <div className="px-16px pb-16px">
                            <p
                              className="text-body-s text-txtsecondary pb-12px mb-12px border-b border-txtsecondary-shades4"
                              dangerouslySetInnerHTML={{ __html: ele.subText }}
                            />

                            <ClaimEtaRow statusItem={ele} className="mb-12px" />

                            {/* CTA */}
                            {ele?.cta && (
                              <button
                                className="w-full rounded-12 border border-primary text-primary font-bold p-12px bg-transparent"
                                style={{ fontSize: 12 }}
                                onClick={() => {
                                  this.props.history.push(
                                    '/reimbursement/fulfillment-details',
                                    {
                                      action: ele?.cta?.action,
                                      claimId: this.state?.claimId,
                                    }
                                  );
                                }}
                              >
                                {ele?.cta?.label}
                              </button>
                            )}
                          </div>
                        </div>
                      ) : ele.active ? (
                        <div className="bg-textbox border border-primary rounded-12 p-12px">
                          <ClaimStagePill />
                          <div className="flex items-start justify-between gap-8px mt-8px">
                            <div className="text-body-s font-semibold text-txtlight">
                              {ele.label}
                            </div>
                            {/* When the stage happened. The ETA row below is
                                the forward-looking date, so the two sit apart
                                rather than reading as one range. */}
                            {ele.dateTime ? (
                              <span className="text-caption-s font-regular text-txtsecondary whitespace-nowrap">
                                {ele.dateTime}
                              </span>
                            ) : null}
                          </div>
                          {ele.description ? (
                            <p className="font-regular text-txtsecondary text-body-s mt-4px">
                              {ele.description}
                            </p>
                          ) : null}
                          <ClaimEtaRow statusItem={ele} className="mt-12px" />
                        </div>
                      ) : (
                        <div className="rounded-12 border border-custom1eb865">
                          <div className="text-body-s font-semibold text-txtlight px-16px py-12px">
                            {ele.label}
                          </div>
                          <div className="txt-black-500-11">
                            {ele.description}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </StepstextContainer>
                <DateText>{ele.dateTime}</DateText>
              </div>
            </div>
          )}
        </div>
      );
    };

    const queryHistoryRender = (ele, idx) => {
      console.log(ele);

      return (
        <QueryBox
          actionTaken={ele?.actionTaken}
          className="shadow-lg"
          onClick={() =>
            this.props.history.push('/claims/query-history', {
              deficientId: ele?.deficientId,
              claimInfoV2: this.state.claimInfoV2,
              baseUrl: this.props.baseUrl,
              documentsDeficientDetails: this.state.documentsDeficientDetails,
            })
          }
        >
          <img
            src={ele?.actionTaken ? lightBlueInfo : redInfo}
            alt=""
            className="flex self-start"
          />
          <div>
            <p className="font-semibold text-body-l mb-2">{ele.queryTitle}</p>
            {ele.documentType && ele.documentType ? (
              <div className="font-regular text-body-s text-sub">
                <span className="font-regular text-black">Documents: </span>
                <span>{ele.documentType}</span>
              </div>
            ) : null}
            {ele.remark && ele.remark ? (
              <div className="font-regular text-body-s text-sub">
                <span className="font-regular text-black">Remarks: </span>
                <span>{ele.remark}</span>
              </div>
            ) : null}
            {ele.doctorComment && ele.doctorComment ? (
              <div className="font-regular text-body-s text-sub">
                <span className="font-regular text-black">Comments: </span>
                <span>{ele.doctorComment}</span>
              </div>
            ) : null}
            <div class="flex items-center justify-between mt-10px">
              <BadgeBox actionTaken={ele?.actionTaken}>
                {ele?.actionTaken ? 'Action Taken' : 'Action Required'}
              </BadgeBox>
              <TimeBox>{ele?.createdAt}</TimeBox>
            </div>
          </div>
          <img src={blackArrowRight} alt="" className="flex self-start" />
        </QueryBox>
      );
    };
    const statusTabs = (
      <>
        <TabsContainer>
          <TabButton
            active={this.state.activeTab === 'claimstatus'}
            onClick={() => this.setState({ activeTab: 'claimstatus' })}
          >
            <img src={chartIcon} alt="" />
            <span>Claim Status</span>
          </TabButton>
          <TabButton
            active={this.state.activeTab === 'queryhistory'}
            onClick={() => this.setState({ activeTab: 'queryhistory' })}
          >
            <img src={chatIcon} alt="" />
            <span>Query History</span>
          </TabButton>
        </TabsContainer>
        {this.state.activeTab.toLowerCase() === 'claimstatus' ? (
          <div className="p-20px pr-0 pb-0 rounded-12 border-box">
            <StepsContainer>{status.map(stepsRender)}</StepsContainer>
          </div>
        ) : (
          <StepsContainer>
            {queryHistory.length > 0 ? (
              queryHistory.map(queryHistoryRender)
            ) : (
              <p className="text-body-s font-regular text-txtsecondary py-24px text-center">
                No queries have been raised on this claim yet.
              </p>
            )}
          </StepsContainer>
        )}
      </>
    );

    return (
      <OuterContainer>
        {/* <HeaderContainer>
          <Header
            title="Claim Status"
            onTap={() => {
              if (this.state.goBack) {
                this.props.history.goBack();
              } else {
                this.props.history.replace('/home');
              }
            }}
          />
          <div className="pr-20px pt-24px w-full flex justify-end items-center">
            <NeedHelp></NeedHelp>
          </div>
        </HeaderContainer> */}
        <Header
          title="Claim Status"
          onTap={() => {
            if (this.state.goBack) {
              this.props.history.goBack();
            } else {
              this.props.history.replace('/home');
            }
          }}
          needHelp={true}
        />
        {this.state.loading ? (
          <LoadingComponent />
        ) : (
          <BodyContainer>
            <div>
              <div>
                {this.state.documentUploadExpired === true ? (
                  <div
                    className="rounded-12 w-full p-16px h-164px mb-20"
                    style={{ background: 'rgba(242, 85, 64, 0.05)' }}
                  >
                    <div className="flex flex-row items-center">
                      <img src={DeniedPermisionIcon} alt="deniend" />
                      <span className="text-title-m ml-10px font-semibold p-64px text-txtlight">
                        Upload Document Request Expired
                      </span>
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </div>
              <div>
                {this.state.claimInfoV2 &&
                this.state.claimInfoV2.claimStatus === 'rejected' ? (
                  <div className="mb-20">
                    <div
                      className="rounded-12 w-full p-16px h-164px "
                      style={{ background: 'rgba(242, 85, 64, 0.05)' }}
                    >
                      <div className="flex flex-row items-center">
                        <img src={DeniedPermisionIcon} alt="deniend" />
                        <span className="text-title-m ml-10px font-semibold p-64px text-txtlight">
                          Claim Rejected
                        </span>
                      </div>
                      {this.state.claimStatusDetails &&
                      this.state.claimStatusDetails.reason ? (
                        <div className="ml-32px">
                          <p>{this.state.claimStatusDetails.reason}</p>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </div>
              <div>
                {isClaimApprovedOrSettled && !hasClaimStatusStep ? (
                  <div className="mb-24px">
                    <div className="mb-20 bg-custom1eb865 bg-opacity-10 rounded-12 p-16px text-body-l text-txtlight font-regular">
                      <div className="flex flex-row items-center">
                        <img src={CircleCheckIcon} alt="checkicon" />
                        <span className="text-body-l ml-10px font-semibold text-txtlight">
                          {paymentDetails &&
                          paymentDetails.settledAmount &&
                          this.state.claimInfoV2 &&
                          this.state.claimInfoV2.claimAmount &&
                          Number(paymentDetails.settledAmount) <
                            Number(this.state.claimInfoV2.claimAmount)
                            ? 'Claim Partially Approved'
                            : 'Claim Approved'}
                        </span>
                      </div>
                      <div
                        className="w-full hover ml-32px pt-4px"
                        onClick={() => {
                          this.onProceed();
                        }}
                      >
                        <p
                          className="text-body-s font-medium"
                          style={{ color: '#3F8CFF' }}
                        >
                          Know More
                        </p>
                      </div>
                    </div>
                    <div className="flex flex-row items-center">
                      <ThemedIcon src={RuppesIcon} alt="rupees" />
                      <p className="text-title-m ml-10px font-semibold p-64px text-txtlight">
                        Payment Details
                      </p>
                    </div>
                    <div className="mt-16px">
                      <div className="rounded-12 border border-custom1eb865 px-16px pt-4px">
                        <div className="flex-start-end align-items-center border-b border-txtsecondary-shades4 py-12px">
                          <span className="text-body-s font-medium text-txtsecondary">
                            Settled Amount
                          </span>
                          <span className="text-body-s font-semibold text-txtlight">
                            {`₹ ${this.state.paymentDetails.settledAmount}`}
                          </span>
                        </div>

                        <div className="flex-start-end align-items-center border-b border-txtsecondary-shades4 py-12px">
                          <span className="text-body-s font-medium text-txtsecondary">
                            UTR Number
                          </span>
                          <span className="text-body-s font-semibold text-txtlight">
                            {this.state.paymentDetails.utrNumber}
                          </span>
                        </div>

                        <div className="flex-start-end align-items-center border-b border-txtsecondary-shades4 py-12px">
                          <span className="text-body-s font-medium text-txtsecondary">
                            Time of transaction
                          </span>
                          <span className="text-body-s font-semibold text-txtlight">
                            {this.state.paymentDetails.timeOfTransaction}
                          </span>
                        </div>

                        <div className="flex-start-end align-items-center border-b border-txtsecondary-shades4 py-12px">
                          <span className="text-body-s font-medium text-txtsecondary">
                            Account Number
                          </span>
                          <span className="text-body-s font-semibold text-txtlight">
                            {this.state.paymentDetails.AccountNumber}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </div>
              <div className="flex flex-row items-center">
                <ThemedIcon src={DetailsIcon} alt="detail" />
                <p className="text-title-m ml-10px font-semibold p-64px text-txtlight">
                  Details
                </p>
              </div>
              <div className="mt-14px mb-24px">
                <div className=" rounded-12 border border-txtsecondary-shades7  opacity-20px">
                  {/* <div className="order-status"> */}
                  <div className="order-status-details">
                    <div className="flex-start-end align-items-center border-b border-txtsecondary-shades4 pb-12px pt-12px">
                      <span className="text-body-s font-medium text-txtsecondary">
                        Claim Id
                      </span>
                      <span className="text-body-s font-semibold text-txtlight">
                        {this.state.claimInfoV2.reimbursementId}
                      </span>
                    </div>
                    {this.state?.claimInfoV2?.tpaClaimId && (
                      <div className="flex-start-end align-items-center border-b border-txtsecondary-shades4 pb-12px pt-12px">
                        <span className="text-body-s font-medium text-txtsecondary">
                          TPA Claim Id
                        </span>
                        <span className="text-body-s font-semibold text-txtlight">
                          {this.state.claimInfoV2.tpaClaimId}
                        </span>
                      </div>
                    )}
                    <div className="flex-start-end align-items-center border-b border-txtsecondary-shades4 pb-12px pt-12px">
                      <span className="text-body-s font-medium text-txtsecondary">
                        Patient Name
                      </span>
                      <span className="text-body-s font-semibold text-txtlight">
                        {this.state?.claimInfoV2?.patientInfo?.name}
                      </span>
                    </div>
                    <div className="flex-start-end align-items-center border-b border-txtsecondary-shades4 pb-12px pt-12px">
                      <span className="text-body-s font-medium text-txtsecondary">
                        Claim Category
                      </span>
                      <span className="text-body-s font-semibold text-txtlight">
                        {this.state.claimInfoV2.procedureName}
                      </span>
                    </div>
                    <div className="flex-start-end align-items-center border-b border-txtsecondary-shades4 pb-12px pt-12px">
                      <span className="text-body-s font-medium text-txtsecondary">
                        Procedure Date
                      </span>
                      <span className="text-body-s font-semibold text-txtlight">
                        {this.state.claimInfoV2.admissionDate}
                      </span>
                    </div>
                    <div className="flex-start-end align-items-center border-b border-txtsecondary-shades4 pb-12px pt-12px">
                      <span className="text-body-s font-medium text-txtsecondary">
                        Requested Amount
                      </span>
                      <span className="text-body-s font-semibold text-txtlight">
                        {`₹ ${this.state.claimInfoV2.claimAmount}`}
                      </span>
                    </div>
                  </div>
                  {/* </div> */}
                </div>
              </div>
            </div>
            {claimStatus === 'rejected' ? (
              ' '
            ) : (
              <div>
                {cashlessSavingCard && (
                  <TopDisclaimerContainer
                    onClick={() => {
                      if (
                        cashlessSavingCard?.data.partnerStatus === 'empanelled'
                      ) {
                        this.props?.history.push('/reimbursement/empaneled', {
                          categoryType: cashlessSavingCard?.data?.category,
                          requestId: cashlessSavingCard?.data.claimId,
                        });
                      } else {
                        this.props?.history.push(
                          '/reimbursement/not-empaneled',
                          {
                            categoryType: cashlessSavingCard?.data?.category,
                            requestId: cashlessSavingCard?.data.claimId,
                          }
                        );
                      }
                    }}
                  >
                    <TopDisclaimer backgroundImage={cashlessSavingCard?.image}>
                      <div
                        className="px-16px py-12px font-bolder text-title-l text-textbox flex flex-col items-center justify-center  h-full"
                        style={{ width: '50%' }}
                      >
                        {cashlessSavingCard?.title}
                      </div>
                    </TopDisclaimer>
                    <div
                      className=" text-chip font-medium px-16px py-10px"
                      dangerouslySetInnerHTML={{
                        __html: replacePlaceholdersWithEffect(
                          cashlessSavingCard?.description,
                          replacements,
                          '#006E68',
                          600
                        ),
                      }}
                    />
                  </TopDisclaimerContainer>
                )}
                {statusTabs}
              </div>
            )}
            {this.state.activeTab === 'claimstatus' ? (
              <>
                {prescriptionFile?.length > 0 ||
                  invoiceFile?.length > 0 ||
                  merFile?.length > 0 ||
                  labReport?.length > 0 ||
                  otherDocumentFiles?.length > 0 ||
                  (this.state.disabilityCertificateFile?.length > 0 && (
                    <div>
                      <div className="flex flex-row items-center">
                        <img src={DocumentUploadIcon} alt="detail" />
                        <p className="text-title-m ml-10px font-semibold p-64px text-txtlight">
                          Documents
                        </p>
                      </div>
                    </div>
                  ))}
                {prescriptionFile?.length > 0 && (
                  <div className="order-status">
                    <div className="order-status-details">
                      <div className="text-body-s font-semibold text-txtlight border-bottom">
                        Prescription
                      </div>
                      <AttachedFilesContainer>
                        {prescriptionFile.map(renderUploadedFile)}
                      </AttachedFilesContainer>
                    </div>
                  </div>
                )}
                {invoiceFile?.length > 0 && (
                  <div className="order-status">
                    <div className="order-status-details">
                      <div className="text-body-s font-semibold text-txtlight border-bottom">
                        Invoices
                      </div>
                      <AttachedFilesContainer>
                        {invoiceFile?.map(renderUploadedFile)}
                      </AttachedFilesContainer>
                    </div>
                  </div>
                )}
                {otherDocumentFiles?.length > 0 && (
                  <div className="order-status">
                    <div className="order-status-details">
                      <div className="text-body-s font-semibold text-txtlight border-bottom">
                        Other Documents
                      </div>
                      <AttachedFilesContainer>
                        {otherDocumentFiles?.map(renderUploadedFile)}
                      </AttachedFilesContainer>
                    </div>
                  </div>
                )}
                {merFile?.length > 0 && (
                  <div className="order-status">
                    <div className="order-status-details">
                      <div className="text-body-s font-semibold text-txtlight border-bottom">
                        Mer
                      </div>
                      <AttachedFilesContainer>
                        {merFile?.map(renderUploadedFile)}
                      </AttachedFilesContainer>
                    </div>
                  </div>
                )}
                {labReport?.length > 0 && (
                  <div className="order-status">
                    <div className="order-status-details">
                      <div className="text-body-s font-semibold text-txtlight border-bottom">
                        Lab Reports
                      </div>
                      <AttachedFilesContainer>
                        {labReport?.map(renderUploadedFile)}
                      </AttachedFilesContainer>
                    </div>
                  </div>
                )}
                {this.state.disabilityCertificateFile?.length > 0 && (
                  <div className="order-status">
                    <div className="order-status-details">
                      <div className="text-body-s font-semibold text-txtlight border-bottom">
                        Disability Certificate
                      </div>
                      <AttachedFilesContainer>
                        {this.state.disabilityCertificateFile?.map(
                          renderUploadedFile
                        )}
                      </AttachedFilesContainer>
                    </div>
                  </div>
                )}{' '}
              </>
            ) : null}
          </BodyContainer>
        )}
        <AttachmentInput
          type="file"
          id="photoAttachment"
          accept="image/*"
          style={{ display: 'none' }}
          onChange={this.onImageDataReceive}
        />
        <AttachmentInput
          type="file"
          id="fileAttachment"
          accept=".pdf"
          style={{ display: 'none' }}
          onChange={this.onPDFDataReceive}
        />
        {showModal && (
          <UploadModal
            hideModal={this.hideModal}
            handleAttachment={this.handleAttachment}
          />
        )}
        {this.state.showMessageModal ? (
          <MessageModal
            header={this.state.modalHeader}
            message={this.state.modalMessage}
            hideModal={this.hideModal}
          />
        ) : (
          ''
        )}
        {this.state.showKnowMoreModal && (
          <ClaimsKnowMore
            hideModal={this.hideModal}
            data={this.state.knowMoreDetails}
            copayPercentage={this.state.knowMoreCopayPercentage}
            totals={this.state.knowMoreTotals}
          />
        )}
      </OuterContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
});
const mapDispatchToProps = (dispatch) => ({
  openFileViewer: (content) => dispatch(openFileViewer(content)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClaimsSummary);
